<template>
  <div class="bikelist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
          <el-form-item :label="$t('bike.name188')"  prop="tenantId">
            <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" @change="handleChange1" :show-all-levels="false" clearable collapse-tags :props="{ lazy: true, checkStrictly: true, multiple: true, lazyLoad: loadOptions }"></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
            <el-input v-model="queryInfo.ebikeModelId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name31')" prop="controllerEdition">
            <el-input v-model="queryInfo.controllerEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name32')" prop="meterEdition">
            <el-input v-model="queryInfo.meterEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name33')" prop="iotEdition">
            <el-input v-model="queryInfo.iotEdition" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('finance.name33')" prop="ebikeId">
            <el-input class="bikeid-input" type="textarea" :rows="1" :placeholder="$t('bike.name568')" v-model="queryInfo.ebikeId"  maxlength="2000" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="$t('bike.name35')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div class="add-user">
      <!-- <el-button type="primary" size="medium" @click="showModeBindDialog" v-if="buttonPerms.indexOf('ebikeModel/bindModel') > -1" >{{ $t('bike.name115') }}</el-button> -->
      <el-button type="primary" size="medium" @click="showVersionConfigurationDialog">{{ $t('tabmenu.name55') }}</el-button>
      <!-- <el-button type="primary" size="medium" @click="changeTransportMode" :loading='loading1' v-if="buttonPerms.indexOf('ebike/sendTransportInfo') > -1">{{ $t('bike.name117') }}</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showFiveCodeDialog" v-if="buttonPerms.indexOf('ebike/importEbikeVin') > -1">{{ $t('bike.name116') }}</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showAddIotNum" v-if="buttonPerms.indexOf('ebike/tenantBindEbike') > -1">分配归属</el-button> -->
      <!-- <el-button type="primary" size="medium" @click="showImportIotNum" v-if="buttonPerms.indexOf('ebike/importTenantBindEbike') > -1">导入分配归属</el-button> -->
      <!-- <el-button size="medium" type="primary" @click="showIOTDialog" v-if="buttonPerms.indexOf('ebike/importIOT') > -1">导入IOT</el-button> -->
      <!-- <el-button size="medium" type="primary" @click="exportEbikeData"  :loading='exportLoading'>导出车辆</el-button> -->
    </div>
    <el-table ref="table"   :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading" @selection-change="onSelectTab">
      <el-table-column type="selection" width="55" align="center" fixed="left" :selectable="selectable"></el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('home.name21')" prop="tenantName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name40')" prop="mac" sortable ></el-table-column>
      <el-table-column :label="$t('bike.name43')" prop="controllerVersion" sortable></el-table-column>
      <el-table-column :label="$t('bike.name106')" prop="meterVersion" sortable></el-table-column>
      <el-table-column :label="$t('bike.name107')" prop="iotVersionNo" sortable></el-table-column>
      <el-table-column :label="$t('bike.name52')" prop="ebikeModelName" sortable></el-table-column>
      <el-table-column :label="$t('bike.name4')" prop="ebikeModelId" sortable></el-table-column>
      <!-- <el-table-column :label="$t('bike.name108')" prop="ebikeVinNo" sortable width="200"></el-table-column> -->
      <el-table-column :label="$t('bike.name109')" prop="motorNo" sortable></el-table-column>
      <el-table-column :label="$t('bike.name110')" prop="remark" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name111')" prop="isTransport" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.isTransport === 0 ? $t('bike.name251') : $t('bike.name252') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name112')" prop="status" sortable>
        <template slot-scope="scope">
          <div class="green" v-if="scope.row.status === 1">
            <div class="text">{{ $t('bike.name45') }}</div>
          </div>
          <div class="red" v-if="scope.row.status === 0">
            <div class="text">{{ $t('bike.name113') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name44')" prop="test" sortable>
        <template slot-scope="scope">
          {{ [$t('bike.name251'),$t('bike.name252')][scope.row.isTest] }}
          <!-- <el-switch class="switch" :value="scope.row.isTest" :active-value="1"  :inactive-value="0" active-color="#0f73e6" inactive-color="#dcdfe6"   :active-text="$t('bike.name252')"  :inactive-text="$t('bike.name251')"> </el-switch> -->
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('bike.name11')" width="140px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/findEbikeDetail') > -1">{{ $t('bike.name46') }}</el-button>
          <el-button type="text" @click="showIotDetailsDialog(scope.row)" v-if="buttonPerms.indexOf('ebike/getIotDetalis') > -1">IOT</el-button>
          <el-button type="text" @click="handleCancelBindModel(scope.row)" v-if="buttonPerms.indexOf('ebikeModel/cancelBindModel') > -1">{{ $t('bike.name114') }}</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--车型绑定-->
    <AppDialog size="sm" :title="$t('bike.name120')" :visible.sync="vehicleModelBindingDialog" v-if="vehicleModelBindingDialog" :before-close="close" >
      <el-form ref="bindingFormRef" :label-width="formLabelWidth()" :model="bindingForm" :rules="bindingFormRules">
        <el-form-item :label="$t('bike.name2')" prop="ebikeModelId">
           <el-select v-model="bindingForm.ebikeModelId" :placeholder="$t('public.name1')">
              <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelId" :value="item.ebikeModelId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="bindingVehicleMode" :loading='loading'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--分配运营商-->
    <AppDialog size="sm" :title="$t('bike.name119')" :visible.sync="assignOperatorsDialog" v-if="assignOperatorsDialog" :before-close="close" >
      <el-form ref="assignOperatorsFormRef" :label-width="formLabelWidth()" :model="assignOperatorsForm"   :rules="assignOperatorsFormRules">
        <el-form-item :label="$t('bike.name406')" prop="tenantId">
          <el-select v-model="assignOperatorsForm.tenantId" :placeholder="$t('public.name1')">
              <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitAssignOperators" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--导入IOT-->
      <AppDialog size="sm" :title="$t('bike.name158')" :visible.sync="iotDialog" v-if="iotDialog" :before-close="close" >
      <el-form ref="iotFormRef" :label-width="formLabelWidth('lg2')" >
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" prop="fiveWayCodeFile" style="width:100%;">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile3" :loading='loading2'>{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

     <!--版本配置-->
     <AppDialog size="sm" :title="$t('bike.name118')" :visible.sync="versionConfigurationDialog" v-if="versionConfigurationDialog" :before-close="close" >
      <el-form ref="versionConfigurationFormRef" :label-width="formLabelWidth()" :model="versionConfigurationForm"  :rules="versionConfigurationFormRules">
        <el-form-item :label="$t('bike.name445')" prop="tenantName">
            {{ versionConfigurationForm.tenantName }}
          </el-form-item>
          <el-form-item :label="$t('bike.name2')" prop="tenantName">
            {{ versionConfigurationForm.ebikeModelId }}
          </el-form-item>
        <el-form-item :label="$t('bike.name20')" prop="hardwareType">
            <el-select v-model="versionConfigurationForm.hardwareType" :placeholder="$t('public.name1')" @change="changeType">
              <el-option v-for="item in typeOptions" :key="item.name" :label="item.label" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bike.name18')" prop="otaFirewareInfoId">
            <el-select v-model="versionConfigurationForm.otaFirewareInfoId" :placeholder="$t('public.name1')">
              <el-option v-for="item in versionNumberOptions" :key="item.name" :label="item.fileName" :value="item.name"> </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitVersionConfiguration" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--导入五通码-->
      <AppDialog size="sm" :title="$t('bike.name576')" :visible.sync="fiveWayCodeUploadDialog" v-if="fiveWayCodeUploadDialog" :before-close="close" >
      <el-form :label-width="formLabelWidth('lg2')">
        <el-form-item :label="$t('bike.name574')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E4%BA%94%E9%80%9A%E7%A0%81EXCEL%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx?Expires=2365230403&OSSAccessKeyId=ULZah0Yxq41iLeaf&Signature=gstHMnwITJS8aCNBItkF%2BYpURqQ%3D">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name575')">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile1" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

    <!--导入分配归属-->
    <AppDialog size="sm" :title="$t('bike.name157')" :visible.sync="importIotNumDialog" v-if="importIotNumDialog" :before-close="close" >
      <el-form :label-width="formLabelWidth('lg2')" ref="importBelongFormRef"  :rules="importBelongFormRules"  :model="importBelong">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/0/1/%E5%AF%BC%E5%85%A5IOT%E6%A8%A1%E7%89%88.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name160')" prop="tenantId">
          <el-cascader v-model="importBelong.tenantId" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" >
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="uploadSectionFile2" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

    <!--分配归属-->
    <AppDialog size="sm" :title="$t('bike.name156')" :visible.sync="addIotNumDialog" v-if="addIotNumDialog" :before-close="close" >
      <el-form ref="belongFormRef"  :label-width="formLabelWidth('lg2')" :rules="belongFormRules"  :model="belong">
        <el-form-item :label="$t('bike.name160')"  prop="tenantId">
            <el-cascader v-model="belong.tenantId" :placeholder="$t('public.name1')" :show-all-levels="false" @change="handleChange" :props="{ lazy: true, checkStrictly: true, lazyLoad: loadOptions }" clearable></el-cascader>
        </el-form-item>

        <!-- <el-form-item :label="$t('bike.name98')">
          <el-input v-model="queryInfo.loginName" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('bike.name99')">
          <el-switch
            v-model="queryInfo.status"
            active-color="#0f73e6"
            inactive-color="#dcdfe6"
            active-value="1"
            inactive-value="0"
            :active-text="$t('bike.name45')"
            :inactive-text="$t('bike.name104')"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitBelong" :loading="loading2">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

     <!--车辆详情-->
     <VehicleDetailsAppDialog
       ref="vehicleDetailsDialog"
       :visible.sync="eBikeDetailsDialog"
       :e-bike-id="eBikeBaseInfo.ebikeId"
       :e-bike-code="eBikeBaseInfo.ebikeCode"
       :type="1"
       @list-changed="queryList"
     />

      <!--修改车辆基本信息-->
      <AppDialog size="sm" :title="$t('bike.name578')" :visible.sync="eBikeBaseInfoDialog" v-if="eBikeBaseInfoDialog" :before-close="closeBaseInfoDialog" >
        <el-form :label-width="formLabelWidth()" style="width:100%;" :model="eBikeBaseInfo">
          <!-- <el-form-item label="web配置：">
            <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('public.name5')"
            v-model="eBikeBaseInfo.webConfiguration">
          </el-input>
        </el-form-item> -->
        <el-form-item :label="$t('finance.name11')">
            <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('public.name5')"
            v-model="eBikeBaseInfo.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="handlerDelBike" :loading="loading3" v-if="userinfo.tenantType === 0">{{ $t('bike.name253') }}</el-button>
        <el-button type="primary" @click="handlerModify" :loading="loading3">{{ $t('public.name13') }}</el-button>
        <el-button @click="closeBaseInfoDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>

      <!--IOT详情-->
      <AppDialog size="lg" :title="$t('bike.name254')" :visible.sync="iotDetailsDialog" v-if="iotDetailsDialog" :before-close="closeIotDetailsDialog">
        <IotDetailsDialog ref="iotDetailsDialogRef" :ebike-id="iotEbikeId"></IotDetailsDialog>
      <template #footer>
        <el-button @click="closeIotDetailsDialog">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import { findEbikeBatchUpgradePage, bindModel, cancelBindModel, findEbikeDetail, sendTransportInfo, tenantBindEbike, importEbikeVin, importTenantBindEbike, importEbikeIdMacNoTenantId, modifyEbikeBaseInfo, findOtaFirmwarePage, findEbikeModelPage, otaFirmwareInfoList2, otaFirmwareInfoList3, sendUpgradeInfo, exportEbike, removeIotEbike } from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { downloadExcel } from '@/utils/utils'
import IotDetailsDialog from '../components/IotDetailsDialog.vue'
import VehicleDetailsAppDialog from '@/components/VehicleDetailsAppDialog.vue'
import AppDialog from '@/components/AppDialog/index.vue'
import { mapGetters } from 'vuex'
import { clearFormValidateOnLangChange } from '@/utils/i18nFormHelpers.js'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    typeAllOptions () {
      return [
        { name: 0, label: 'IOT' },
        { name: 1, label: this.$t('bike.name14') },
        { name: 2, label: this.$t('bike.name413') }
      ]
    },
    statusOptions () {
      return [
        { value: '1', label: this.$t('bike.name45') },
        { value: '0', label: this.$t('bike.name227') }
      ]
    },
    belongFormRules () {
      return {
        tenantId: [{ required: true, message: this.$t('public.name45'), trigger: 'blur' }]
      }
    },
    importBelongFormRules () {
      return {
        tenantId: [{ required: true, message: this.$t('public.name45'), trigger: 'blur' }]
      }
    },
    bindingFormRules () {
      return {
        ebikeModelId: [{ required: true, message: this.$t('bike.name468'), trigger: 'blur' }]
      }
    },
    assignOperatorsFormRules () {
      return {
        tenantId: [{ required: true, message: this.$t('bike.name469'), trigger: 'blur' }]
      }
    },
    versionConfigurationFormRules () {
      return {
        otaFirewareInfoId: [{ required: true, message: this.$t('bike.name470'), trigger: 'blur' }],
        hardwareType: [{ required: true, message: this.$t('bike.name471'), trigger: 'blur' }]
      }
    },
    modelFromRules () {
      return {
        ebikeModelId: [{ required: true, message: this.$t('bike.name472'), trigger: 'blur' }]
      }
    }
  },
  data() {
    return {
      tenantAll: [],
      tenantIds: '',
      iotDetailsDialog: false,
      iotEbikeId: '',
      eBikeBaseInfoDialog: false,
      iotDialog: false,
      eBikeBaseInfo: {
        ebikeId: '',
        ebikeCode: '',
        remark: ''
      },
      typeOptions: [],
      loading1: false,
      loading2: false,
      loading3: false,
      exportLoading: false,
      importIotNumDialog: false,
      assignOperatorsDialog: false,
      versionConfigurationDialog: false,
      fiveWayCodeUploadDialog: false,
      eBikeDetailsDialog: false,
      eBikeDetails: {},
      addIotNumDialog: false,
      vehicleModelBindingDialog: false,
      tenantOptions: [],
      modelOptions: [],
      bindingForm: {
        ebikeModelId: '',
        ebikeIdList: []
        // ebikeVinNo: ''
      },
      fileList: [],
      belong: {
        tenantId: []
      },
      importBelong: {
        tenantId: []
      },
      assignOperatorsForm: {
        tenantId: ''
      },
      versionConfigurationForm: {
        hardwareType: '',
        otaFirewareInfoId: '',
        ebikeIdList: [],
        tenantId: '',
        tenantName: '',
        ebikeModelId: ''
      },
      queryInfo: {
        status: '',
        pageNumber: 1,
        pageSize: 10,
        ebikeId: '',
        controllerEdition: '',
        meterEdition: '',
        iotEdition: '',
        permTenantList: [],
        ebikeModelId: ''
      },
      tableLoading: false,
      loading: false,
      selectionList: [],
      total: 0,
      tableList: [],
      options: [],
      ridelist: [
        {
          bikeCode: '',
          email: '',
          remark: '',
          ebikeId: '',
          type: '',
          bikeMac: '',
          status: '',
          isTransport: '',
          controllerEdition: '',
          meterEdition: '',
          iotEdition: '',
          ebikeModelId: '',
          ebikeModelName: '',
          motorNo: '',
          ebikeVinNo: ''
        }
      ],
      isTransportlist: [],

      // 详情提示框
      ebikeId: '',
      dialogBikeInfoVisible: false,
      IOTebikeId: '',
      dialogIoTisible: false,
      // 延迟
      // 车型绑定
      modelist: [],
      modelVisible: false,
      modelFrom: {
        ebikeModelId: '',
        ebikeId: [],
        ebikeVinNo: ''
      },
      // OTA升级
      selectlist: [],
      disposeOTAVisible: false,
      disposeOTAFrom: {
        ebikeId: [],
        hardwareType: '',
        versionNumber: ''
      },
      versionNumberOptions: [],
      TypefirmwareList: [],
      fiveWayCodeFile: null,
      ImportbikeVisible: false,
      buttonPerms: '',
      tenantAllOptions: []
    }
  },
  components: {
    IotDetailsDialog,
    VehicleDetailsAppDialog,
    AppDialog
  },
  created() {
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getTenantList()
    this.getEbikeModelList()
    this.$bus.$on('lang', this.handleLangChange)
    // this.getOtaFirmwareInfoLlist2()
  },
  beforeDestroy() {
    this.$bus.$off('lang', this.handleLangChange)
  },
  methods: {
    handleLangChange () {
      clearFormValidateOnLangChange(this, [
        'bindingFormRef',
        'assignOperatorsFormRef',
        'versionConfigurationFormRef',
        'importBelongFormRef',
        'belongFormRef'
      ])
    },
    resetQuery() {
      this.queryInfo.status = ''
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryInfo.ebikeId = ''
      this.queryInfo.controllerEdition = ''
      this.queryInfo.meterEdition = ''
      this.queryInfo.iotEdition = ''
      this.queryInfo.ebikeModelId = ''
      this.queryInfo.permTenantList = []
      this.tenantIds = []
      this.queryList()
    },
    exportEbikeData() {
      this.exportLoading = true
      this.queryInfo.ebikeId = this.queryInfo.ebikeId.trim()
      this.queryInfo.controllerEdition = this.queryInfo.controllerEdition.trim()
      this.queryInfo.meterEdition = this.queryInfo.meterEdition.trim()
      this.queryInfo.iotEdition = this.queryInfo.iotEdition.trim()
      exportEbike(this.queryInfo).then(res => {
        this.exportLoading = false
        downloadExcel(res, this.$t('bike.name229'))
      }).catch(() => {
        this.exportLoading = false
      })
    },
    getEbikeModelList() {
      const queryInfo = {
        pageNumber: 1,
        pageSize: 500
      }
      findEbikeModelPage(queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    showImportIotNum() {
      this.importIotNumDialog = true
    },
    selectable(row, index) {
      if (row.ebikeModelId) {
        return true
      } else {
        return false
      }
    },
    showAddIotNum() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.addIotNumDialog = true
    },
    showAssignOperatorsDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      this.assignOperatorsDialog = true
    },
    showVersionConfigurationDialog() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      const manufacturerIdList = []
      const ebikeModelIdList = []
      this.selectionList.map((item) => {
        if (item.ebikeModelId !== null) {
          ebikeModelIdList.push(item.ebikeModelId)
        }
        manufacturerIdList.push(item.manufacturerId)
      })
      var isShow1 = this.areAllElementsSame(manufacturerIdList)
      var isShow2 = this.areAllElementsSame(ebikeModelIdList)
      if (isShow1 && isShow2 && ebikeModelIdList.length > 0) {
        this.versionConfigurationForm.tenantId = this.selectionList[0].manufacturerId
        this.versionConfigurationForm.tenantName = this.selectionList[0].manufacturerName
        this.versionConfigurationForm.ebikeModelId = this.selectionList[0].ebikeModelId
        this.getOtaFirmwareInfoLlist2()
        this.versionConfigurationDialog = true
      } else {
        this.$message.warning(this.$t('bike.name584'))
      }
    },
    areAllElementsSame(array) {
      if (array.length <= 1) {
        return true
      }
      for (let index = 1; index < array.length; index++) {
        if (array[index] !== array[index - 1]) {
          return false
        }
      }
      return true
    },
    showFiveCodeDialog() {
      this.fiveWayCodeUploadDialog = true
    },
    showDetailsDialog(row) {
      this.eBikeBaseInfo.ebikeId = row.ebikeId
      this.eBikeBaseInfo.ebikeCode = row.ebikeCode
      this.eBikeDetailsDialog = true
    },
    showBaseInfoDialog() {
      this.eBikeBaseInfoDialog = true
    },
    handlerDelBike() {
      this.$confirm(this.$t('bike.name381'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          removeIotEbike({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
            if (res.code === 200) {
              this.closeBaseInfoDialog()
              this.eBikeDetailsDialog = false
              if (this.$refs.vehicleDetailsDialog) {
                this.$refs.vehicleDetailsDialog.close()
              }
              this.getPageList()
              this.$message({ type: 'success', message: this.$t('public.name30') })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handlerModify() {
      this.loading3 = true
      modifyEbikeBaseInfo(this.eBikeBaseInfo)
        .then((res) => {
          this.loading3 = false
          if (res.code === 200) {
            findEbikeDetail({ ebikeId: this.eBikeBaseInfo.ebikeId }).then((res) => {
              if (res.code === 200) {
                this.eBikeDetails = res.data.iotEbike
              }
            })
            this.closeBaseInfoDialog()
          }
        })
        .catch(() => {
          this.loading3 = false
        })
    },
    closeBaseInfoDialog() {
      this.eBikeBaseInfoDialog = false
      this.eBikeBaseInfo = {
        ebikeId: '',
        remark: ''
      }
      // this.pageSize = 10
      // this.pageNumber = 1
      // this.alarmTotal = 0
      // this.alarmMessageList = []
    },
    showIotDetailsDialog(row) {
      this.iotEbikeId = row.ebikeId
      this.iotDetailsDialog = true
    },
    closeIotDetailsDialog() {
      if (this.$refs.iotDetailsDialogRef) {
        this.$refs.iotDetailsDialogRef.close()
      }
      this.iotDetailsDialog = false
      this.iotEbikeId = ''
    },
    submitVersionConfiguration() {
      this.$refs.versionConfigurationFormRef.validate((valid) => {
        if (valid) {
          this.loading2 = true
          this.versionConfigurationForm.ebikeIdList = []
          this.versionConfigurationForm.tenantId = this.queryInfo.tenantId
          this.selectionList.map((item, index) => {
            this.versionConfigurationForm.ebikeIdList.push(item.ebikeId)
          })
          sendUpgradeInfo(this.versionConfigurationForm)
            .then((res) => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitAssignOperators() {
      this.$refs.assignOperatorsFormRef.validate(valid => {
        if (valid) {
          this.loading2 = true
          const ebikeIdList = []
          this.selectionList.map((item, index) => {
            ebikeIdList.push(item.ebikeId)
          })
          tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.assignOperatorsForm.tenantId })
            .then(res => {
              this.loading2 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading2 = false
            })
        } else {
          return false
        }
      })
    },
    submitBelong() {
      this.$refs.belongFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('public.name32'), this.$t('public.name23'), {
            confirmButtonText: this.$t('public.name25'),
            cancelButtonText: this.$t('public.name14'),
            type: 'warning'
          })
            .then(() => {
              this.loading2 = true
              const ebikeIdList = []
              this.selectionList.map((item, index) => {
                ebikeIdList.push(item.ebikeId)
              })
              tenantBindEbike({ ebikeIdList: ebikeIdList, tenantId: this.belong.tenantId })
                .then((res) => {
                  this.loading2 = false
                  if (res.code === 200) {
                    this.$refs.table.clearSelection()
                    this.close()
                    this.queryList()
                  }
                })
                .catch(() => {
                  this.loading2 = false
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('public.name33')
              })
            })
        } else {
          return false
        }
      })
    },
    changeTransportMode() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.$t('bike.name380'))
        return
      }
      if (this.selectionList.length > 1) {
        this.$message.warning(this.$t('bike.name382'))
        return
      }
      const ebikeIdList = []
      this.selectionList.map((item, index) => {
        ebikeIdList.push(item.ebikeId)
      })
      this.$confirm(this.$t('bike.name383'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.loading1 = true
          sendTransportInfo({ ebikeId: ebikeIdList[0] })
            .then(res => {
              this.loading1 = false
              if (res.code === 200) {
                this.$refs.table.clearSelection()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading1 = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    close() {
      this.closeIotDetailsDialog()
      this.vehicleModelBindingDialog = false
      this.assignOperatorsDialog = false
      this.assignOperatorsForm = {
        tenantId: ''
      }
      this.versionConfigurationDialog = false
      this.fiveWayCodeUploadDialog = false
      if (this.$refs.vehicleDetailsDialog) {
        this.$refs.vehicleDetailsDialog.close()
      }
      this.eBikeDetailsDialog = false
      this.bindingForm = {
        ebikeModelId: '',
        ebikeIdList: []
      }
      this.importIotNumDialog = false
      this.addIotNumDialog = false
      this.belong = {
        tenantId: ''
      }
      this.importBelong = {
        tenantId: ''
      }
      this.versionConfigurationForm.hardwareType = ''
      this.versionConfigurationForm.otaFirewareInfoId = ''
      this.versionConfigurationForm.ebikeIdList = []
      this.versionConfigurationForm.tenantId = ''
      this.versionConfigurationDialog = false
      this.iotDialog = false
    },
    getPageList() {
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    buildBikeListParams(pageNumber, pageSize) {
      return {
        ...this.queryInfo,
        pageNumber,
        pageSize,
        ebikeId: (this.queryInfo.ebikeId || '').trim(),
        controllerEdition: (this.queryInfo.controllerEdition || '').trim(),
        meterEdition: (this.queryInfo.meterEdition || '').trim(),
        iotEdition: (this.queryInfo.iotEdition || '').trim(),
        ebikeModelId: (this.queryInfo.ebikeModelId || '').trim()
      }
    },
    async queryList() {
      this.tableLoading = true
      try {
        const params = this.buildBikeListParams(this.queryInfo.pageNumber, this.queryInfo.pageSize)
        const res = await findEbikeBatchUpgradePage(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.page && res.data.page.records) || []
          this.total = (res.data && res.data.page && res.data.page.total) || 0
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getBikeList() {
      return this.queryList()
    },
    showModeBindDialog() {
      if (this.selectionList.length > 0) {
        this.selectionList.map((item, index) => {
          this.bindingForm.ebikeIdList.push(item.ebikeId)
        })
        this.vehicleModelBindingDialog = true
      } else {
        this.$message.warning(this.$t('bike.name380'))
      }
    },
    bindingVehicleMode() {
      this.$refs.bindingFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          bindModel(this.bindingForm).then(res => {
            this.loading = false
            // console.log('===', res.code)
            if (res.code === 200) {
              this.queryList()
              this.$refs.table.clearSelection()
              this.close()
            }
          }).catch(() => {
            this.loading = false
          })
          this.close()
        } else {
          return false
        }
      })
    },
    handleCancelBindModel(row) {
      this.$confirm(this.$t('bike.name384'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          cancelBindModel({ ebikeIdList: [row.ebikeId] }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('bike.name385')
              })
              this.queryInfo.pageNumber = 1
              this.queryList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('bike.name386')
          })
        })
    },
    onSelectTab(selection) {
      this.selectionList = selection
    },
    loadOptions(node, resolve) {
      // console.log('===', node)
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 3,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 2
            }))
            resolve(options)
          } else {
            resolve([])
          }
          if (node.level === 0) {
            // this.versionConfigurationForm.tenantName = res.data.list[0].tenantName
            this.getPageList()
            // this.getOtaFirmwareInfoLlist2()
          }
        })
        .catch(() => {})
    },
    versionLoadOptions(node, resolve) {
      console.log('====', node)
      let data = {
        pageNumber: 1,
        pageSize: 500
      }
      if (node.level === 1) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          tenantId: node.value
        }
      }
      if (node.level === 2) {
        data = {
          pageNumber: 1,
          pageSize: 500,
          parentId: node.value
        }
      }
      findOtaFirmwarePage(data).then((res) => {
        var options = []
        if (node.level === 0) {
          options = res.data.page.records.map((item) => ({ value: item.tenantId, label: item.tenantName, leaf: node.level >= 2 }))
        }
        if (node.level === 1) {
          options = res.data.page.records.map((item) => ({
            value: item.firmwareType,
            label: ['IOT', this.$t('bike.name14'), this.$t('bike.name413')][item.firmwareType],
            leaf: node.level >= 2
          }))
        }
        resolve(options)
      }).catch(() => {})
    },
    handleVersionChange(value) {},
    handleChange(value) {
      console.log('value===', value)
      // 处理选项变化
      this.belong.tenantId = value[value.length - 1]
      this.importBelong.tenantId = value[value.length - 1]
      this.$nextTick(() => {
        const dom = document.getElementsByClassName('el-radio is-checked')[0]
        const brother = dom.nextElementSibling
        brother.click()
      })
    },
    handleChange1(value) {
      // 处理选项变化
      this.queryInfo.permTenantList = []
      if (value.length > 0) {
        value.map((item) => {
          this.queryInfo.permTenantList.push(item[item.length - 1])
        })
      }
      // const panelRefs = this.$refs.refHandle.$refs.panel
      // if (panelRefs.activePath.length !== 0) {
      //   panelRefs.activePath.forEach(item => {
      //     if (item.children.length === 0) {
      //       panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      //     }
      //   })
      // }
      this.getPageList()
      // this.getOtaFirmwareInfoLlist2()
    },
    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          loading.close()
          downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
          this.queryList()
        })
        .catch(res => {
          loading.close()
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    },

    // 导入五通码
    Importbike() {
      this.ImportbikeVisible = true
    },
    ImportbikeDialogBefore() {
      this.ImportbikeVisible = false
    },
    uploadFile(file) {
      this.fiveWayCodeFile = file
    },
    delFile() {
      this.fiveWayCodeFile = null
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
      // let obj = new Object()
      // obj.name = e.target.files[0].name
      // obj.url = e.target.files[0].name
      // this.fileList = [{}]
      // console.log('e===', e.target.files[0])
    },
    uploadSectionFile1() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeVin(formData)
        .then(res => {
          this.loading2 = false
          // if (res.code === 200) {
          downloadExcel(res, this.$t('bike.name390'), 'xlsx', true)
          this.$refs.table.clearSelection()
          this.queryList()
          this.fiveWayCodeUploadDialog = false
          this.fiveWayCodeFile = null

          // }
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    uploadSectionFile2() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('tenantId', this.importBelong.tenantId)
      this.loading2 = true
      importTenantBindEbike(formData)
        .then(res => {
          this.loading2 = false
          // if (res.code === 200) {
          downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
          this.$refs.table.clearSelection()
          this.queryList()
          this.importIotNumDialog = false
          this.importBelong.tenantId = ''
          this.fiveWayCodeFile = null

          // }
        })
        .catch(res => {
          this.loading2 = false
        })
    },
    showIOTDialog() {
      this.iotDialog = true
    },
    uploadSectionFile3() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      this.loading2 = true
      importEbikeIdMacNoTenantId(formData)
        .then(res => {
          this.loading2 = false
          // if (res.code === 200) {
          downloadExcel(res, this.$t('bike.name387'), 'xlsx', true)
          this.queryList()
          this.iotDialog = false
          this.fiveWayCodeFile = null

          // }
        })
        .catch(res => {
          this.loading2 = false
        })
    },

    onUploadSuccess() {
      this.$message.success(this.$t('public.name64'))
      this.$refs.uploadss.clearFiles()
      this.ImportbikeVisible = false
      this.getBikes()
    },
    beforebikeupload(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (size > 50) {
        this.$message.warning(this.$t('public.name65'))
        return false
      }
      if (extension !== 'xlsx') {
        this.$message.warning(this.$t('public.name66'))
        return false
      }
    },
    getOtaFirmwareInfoLlist2() {
      this.typeOptions = []
      const data = {
        tenantId: this.versionConfigurationForm.tenantId,
        ebikeModelId: this.versionConfigurationForm.ebikeModelId
      }
      otaFirmwareInfoList2(data)
        .then((res) => {
          res.data.map((item) => {
            this.typeAllOptions.map((items) => {
              if (item === items.name) {
                const obj = {}
                obj.name = items.name
                obj.label = items.label
                this.typeOptions.push(obj)
              }
            })
          })
        })
        .catch(() => {
          this.typeOptions = []
        })
    },
    changeType(e) {
      const data = {
        tenantId: this.versionConfigurationForm.tenantId,
        ebikeModelId: this.versionConfigurationForm.ebikeModelId,
        firmwareType: e
      }
      otaFirmwareInfoList3(data)
        .then((res) => {
          this.versionNumberOptions = res.data
        })
        .catch(() => {
          this.versionNumberOptions = []
        })
    }
  }
}
</script>
<style lang="scss">

.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*打开时文字位置设置*/
.switch .el-switch__label--right {
  z-index: 1;
}

/* 调整打开时文字的显示位子 */
.switch .el-switch__label--right span {
  margin-left: 9px;
}

/*关闭时文字位置设置*/
.switch .el-switch__label--left {
  z-index: 1;
}

/* 调整关闭时文字的显示位子 */
.switch .el-switch__label--left span {
  margin-left: 22px;
}

/*显示文字*/
.switch .el-switch__label.is-active {
  display: block;
}

/* 调整按钮的宽度 */
.switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
  margin: 0;
}

</style>

<style lang="scss" scoped>
.bikelist-container {
  .bikeid-input {
  ::v-deep .el-input__count {
    color: #909399;
    background: #FFF;
    position: absolute;
    font-size: 12px;
    bottom: -36px !important;
    right: 10px;
  }
}

  display: flex;
  flex-direction: column;
  .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .add-user{
    display: flex;
    flex-direction: row;
  }

  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      width: 50%;
      text-align: center;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
